import { VStack } from '@chakra-ui/react';
import LoginForm from '../components/login_form';

const LoginPage = () => {
  return (
    <VStack justify={'center'} height={'400px'} backgroundColor={'#212134'} padding={20} justifySelf={'center'} zIndex={99}>
      <LoginForm />
    </VStack>
  );
};

export default LoginPage;
